import React, { PureComponent } from 'react';
import { pluralHelper } from '../../helpers/stringutils';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SetPassenger } from '../../actions/cart';
import { AddPassenger } from '../../actions/passenger';
import { FetchBooking } from '../../actions/booking';
import { withApollo } from 'react-apollo';
import UserSvg from './UI/userSvg';

class TravellerPanel extends PureComponent {

    constructor(props){
        super(props);

        this.state = {
            adult:1
        }
        this.onPassengerChange = this.onPassengerChange.bind(this);
    }

    componentDidMount(){

        const { paxNumber, isTrips, SetPassenger } = this.props;
      
        //Set initial passenger
        if(isTrips){
           SetPassenger(this.state.adult)
        }else{
            this.setState({adult:paxNumber});
        }
        
        
    }

    AddPassengerToBooking(paxNum){
        const {client, uuid } = this.props;
    
        AddPassenger(client, uuid, paxNum).then(()=>{
            FetchBooking(client, uuid);
        });
    }

    onPassengerChange(direction){

        const { adult } = this.state;
        const { SetPassenger, isTrips } = this.props;
  
        if(direction === 'down'){
            if(adult > 0) this.setState({adult: adult - 1}, () => {isTrips ? SetPassenger(this.state.adult) : this.AddPassengerToBooking(this.state.adult)} );
        }
        if(direction === 'up'){
            if(adult < 10) this.setState({adult: adult + 1}, () => {isTrips ? SetPassenger(this.state.adult) : this.AddPassengerToBooking(this.state.adult)} );
        }
    
    }

    render(){

  

        const { paxNumber, isTrips, /*match:{params:{id}}*/  } = this.props;
        const _tripOrStandard = isTrips ? this.state.adult : paxNumber;

       // if(isTrips && id !== undefined) return null;

        return (
            <div className={`panel small-panel round-corners black-text ${this.props.clazz || ""}`}>
            <div className="clearfix flex">
                  <div className="flex col col-5 items-center">
                    <UserSvg clazz={"user inline-block xs-hide"} />
                    <span className="inline-block bold uppercase">
                      Travellers
                    </span>
                  </div>
                  <div className="flex col col-7 justify-end items-center">
                    <button type="button" className={`${(_tripOrStandard === 0) ? "disabled": ""}`} onClick={e => this.onPassengerChange('down')}>
                        <span className="down-button"><svg className="inline-block" viewBox="0 0 24 24" role="img" aria-label="subtract" focusable="false" style={{'height':'1.5em', 'width': '1.5em', 'display': 'block', 'fill': 'currentcolor' }}><rect height="2" rx="1" width="12" x="6" y="11"></rect></svg></span>
                    </button>

                    <span className="pax-number">{ _tripOrStandard } {pluralHelper("Adult", _tripOrStandard)}</span>

                    <button type="button" className={`${(_tripOrStandard === 10) ? "disabled": ""}`} onClick={e => this.onPassengerChange('up')}>
                        <span><svg className="inline-block" viewBox="0 0 25 25" role="img" aria-label="add" focusable="false" style={{'height':'1.5em', 'width': '1.5em', 'display': 'block', 'fill': 'currentcolor' }}><rect height="2" rx="1" width="12" x="6" y="11"></rect><rect height="12" rx="1" width="2" x="11" y="6"></rect></svg></span>
                    </button>
                </div>
            </div>  
          </div>
        )
    }
}

const mapStateToProps = state => {
    return{
        uuid:state.currentBooking.uuid,
        paxNumber:(state.currentBooking.passengers !== undefined) ? state.currentBooking.passengers.length : 0
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        SetPassenger
    }, dispatch);
}
  
export default withApollo(connect(mapStateToProps, mapDispatchToProps)(TravellerPanel));
  